import { render, staticRenderFns } from "./projectthree.vue?vue&type=template&id=324330e6&scoped=true&"
import script from "./projectthree.vue?vue&type=script&lang=js&"
export * from "./projectthree.vue?vue&type=script&lang=js&"
import style0 from "./projectthree.vue?vue&type=style&index=0&id=324330e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324330e6",
  null
  
)

export default component.exports